import React, { useEffect, useState } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { dataVisColors } from "@mercedes-benz/mui5-theme";
import { useTheme } from "@mui/material";

const LineChartBiaxial = ({ data, width, height }) => {
    const theme = useTheme();
    const [colorScheme, setColorScheme] = useState([]);

    useEffect(() => {
        const themeType = theme.palette.mode === 'light' ? 'light' : 'dark';
        setColorScheme(dataVisColors.basic[themeType]);
    }, [theme.palette.mode]);

    const chartSetting = {
        width: width,
        height: height,
    };

    return (
        <LineChart
            series={[
                { data: data.seriesData1, label: data.label1, yAxisKey: 'leftAxisId' },
                { data: data.seriesData2, label: data.label2, yAxisKey: 'rightAxisId' }
            ]}
            xAxis={[{ scaleType: 'point', data: data.xAxis }]}
            yAxis={[{ id: 'leftAxisId' }, { id: 'rightAxisId' }]}
            rightAxis="rightAxisId"
            colors={colorScheme}
            {...chartSetting}
        />
    );
};

export default LineChartBiaxial;
